// The extraction form floats a table's add/remove row buttons (`position: absolute`); inside the drawer they would
// pin to the drawer's corner, over its close button. In the worksheet each sits in flow, at the right under its row.
export const structuredFieldStyles = {
  '& .MuiFab-root': {
    position: 'static',
    display: 'flex',
    marginLeft: 'auto',
  },
};
